<form [formGroup]="form" (ngSubmit)="salvar()" class="n-form">
  <lib-n-fieldset icon="pi pi-user" [title]="'BARDO_CLIENTES.INFORMACOES_CLIENTE' | translate: { termo: $nicho().cliente.singular }">
    <div class="grid">
      <!-- Nome -->
      <div class="col-12">
        <lib-form-field
          [label]="'BARDO_CLIENTES.NOME_COMPLETO' | translate"
          controlName="nome"
          [required]="true"
          [helpText]="'BARDO_CLIENTES.NOME_HINT' | translate"
        >
          <input
            pInputText
            id="nome"
            formControlName="nome"
            [placeholder]="'BARDO_CLIENTES.NOME_PLACEHOLDER' | translate: { termo: ($nicho().cliente.singular | lowercase) }"
            class="w-full"
          />
        </lib-form-field>
      </div>


      <!-- Telefone -->
      <div class="col-12">
        <lib-form-field
          [label]="'BARDO_CLIENTES.TELEFONE_WHATSAPP' | translate"
          controlName="telefone"
          [required]="true"
        >
          <lib-phone-input
            [value]="form.get('telefone')?.value ?? ''"
            (valueChange)="onTelefoneChange($event)"
          />
        </lib-form-field>
      </div>

      <!-- Data de Nascimento -->
      <div class="col-12 lg:col-6">
        <lib-form-field
          [label]="'BARDO_CLIENTES.DATA_NASCIMENTO' | translate"
          controlName="dataNascimento"
          [required]="true"
        >
          @if (deviceService.$isMobile()) {
          <input
            pInputText
            type="date"
            formControlName="dataNascimento"
            class="w-full"
            [max]="dataMaximaNascimentoIso"
          />
          } @else {
          <p-datepicker
            id="dataNascimento"
            formControlName="dataNascimento"
            dateFormat="dd/mm/yy"
            [placeholder]="'BARDO_CLIENTES.FORMATO_DATA_PLACEHOLDER' | translate"
            [showIcon]="true"
            [maxDate]="dataMaximaNascimento"
            styleClass="w-full"
            (onInput)="aplicarMascaraData($event)"
            [appendTo]="$dropdownAppendTo()"
          />
          }
        </lib-form-field>
      </div>

      <!-- Sexo -->
      <div class="col-12 lg:col-6">
        <lib-form-field [label]="'BARDO_CLIENTES.SEXO' | translate" controlName="sexo">
          @if (deviceService.$isMobile()) {
          <lib-n-multiselect
            [multiple]="false"
            formControlName="sexo"
            [options]="sexoOpcoes"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_CLIENTES.SELECIONE' | translate"
          />
          } @else {
          <p-select
            id="sexo"
            formControlName="sexo"
            [options]="sexoOpcoes"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_CLIENTES.SELECIONE' | translate"
            [emptyMessage]="'BARDO_SERVICOS.NENHUM_RESULTADO' | translate"
            styleClass="w-full"
            [showClear]="true"
            [appendTo]="$dropdownAppendTo()"
          />
          }
        </lib-form-field>
      </div>

      <!-- Opção de Cadastrar Dependente Junto (logo após Data de Nascimento e Sexo) -->
      @if (!cliente?.id) {
      <div class="col-12 my-2">
        <div
          class="flex align-items-center justify-content-between p-3 border-round border-1 surface-border surface-card shadow-1 gap-2"
        >
          <div class="flex align-items-center gap-2 lg:gap-3 min-w-0 flex-1">
            <i class="pi pi-users text-primary text-xl lg:text-2xl flex-shrink-0"></i>
            <div class="min-w-0 flex-1">
              <span class="font-bold text-900 block text-sm sm:text-base">{{ 'BARDO_CLIENTES.CADASTRAR_DEPENDENTE' | translate }}</span>
              <span class="text-secondary text-xs sm:text-sm block line-height-2">
                {{ 'BARDO_CLIENTES.CADASTRAR_DEPENDENTE_DESC' | translate: { termo: ($nicho().cliente.singular | lowercase) } }}
              </span>
            </div>
          </div>
          <div class="flex-shrink-0 ml-2">
            <p-toggleswitch formControlName="cadastrarDependente" />
          </div>
        </div>

        @if (form.get('cadastrarDependente')?.value) {
        <div class="mt-3">
          <lib-n-fieldset icon="pi pi-user-plus" [title]="'BARDO_CLIENTES.INFORMACOES_DEPENDENTE' | translate">
            <div class="grid">
              <!-- Nome do Dependente -->
              <div class="col-12">
                <lib-form-field
                  [label]="'BARDO_CLIENTES.NOME_COMPLETO_DEPENDENTE' | translate"
                  controlName="nomeDependente"
                  [required]="true"
                  [helpText]="'BARDO_CLIENTES.NOME_HINT' | translate"
                >
                  <input
                    pInputText
                    id="nomeDependente"
                    formControlName="nomeDependente"
                    [placeholder]="'BARDO_CLIENTES.NOME_DEPENDENTE_PLACEHOLDER' | translate"
                    class="w-full"
                  />
                </lib-form-field>
              </div>

              <!-- Data de Nascimento do Dependente -->
              <div class="col-12">
                <lib-form-field
                  [label]="'BARDO_CLIENTES.DATA_NASCIMENTO_DEPENDENTE' | translate"
                  controlName="dataNascimentoDependente"
                  [required]="true"
                >
                  @if (deviceService.$isMobile()) {
                  <input
                    pInputText
                    type="date"
                    formControlName="dataNascimentoDependente"
                    class="w-full"
                    [max]="dataMaximaNascimentoIso"
                  />
                  } @else {
                  <p-datepicker
                    id="dataNascimentoDependente"
                    formControlName="dataNascimentoDependente"
                    dateFormat="dd/mm/yy"
                    placeholder="DD/MM/AAAA"
                    [showIcon]="true"
                    [maxDate]="dataMaximaNascimento"
                    styleClass="w-full"
                    (onInput)="aplicarMascaraData($event)"
                    [appendTo]="$dropdownAppendTo()"
                  />
                  }
                </lib-form-field>
              </div>
            </div>
          </lib-n-fieldset>
        </div>
        }
      </div>
      }

      <!-- Email -->
      <div class="col-12">
        <lib-form-field [label]="'BARDO_CLIENTES.EMAIL' | translate" controlName="email">
          <input
            pInputText
            id="email"
            formControlName="email"
            placeholder="email@exemplo.com"
            class="w-full"
          />
        </lib-form-field>
      </div>

      <!-- Endereço -->
      <div class="col-12">
        <lib-form-field [label]="'BARDO_CLIENTES.ENDERECO' | translate" controlName="endereco">
          <input
            pInputText
            id="endereco"
            formControlName="endereco"
            [placeholder]="'BARDO_CLIENTES.ENDERECO_PLACEHOLDER' | translate"
            maxlength="500"
            class="w-full"
          />
        </lib-form-field>
      </div>

      <!-- Observação -->
      <div class="col-12">
        <lib-form-field [label]="'BARDO_CLIENTES.OBSERVACAO' | translate" controlName="observacao">
          <textarea
            pTextarea
            id="observacao"
            formControlName="observacao"
            [placeholder]="'BARDO_CLIENTES.OBSERVACAO_PLACEHOLDER' | translate: { termo: ($nicho().cliente.singular | lowercase) }"
            rows="3"
            class="w-full"
          ></textarea>
        </lib-form-field>
      </div>

    </div>
  </lib-n-fieldset>
</form>

<ng-template #footerTemplate>
  <p-button
    class="w-full"
    [label]="'BARDO_CLIENTES.SALVAR' | translate: { termo: $nicho().cliente.singular }"
    icon="pi pi-check"
    (onClick)="salvar()"
    [loading]="salvando()"
    [disabled]="form.invalid || salvando()"
    styleClass="w-full"
  />
</ng-template>

